/*
 * Copyright (C) 2019 Frontier Developments PLC.
 */

import {Component, Vue} from 'vue-property-decorator';
import UserDescription from '@/components/UserDescription/index.vue';
import CommentsForm from '@/components/CommentsForm/index.vue';
import {Action, Getter} from 'vuex-class';
import {
    ContributionConfigInterface, Contributions,
    ContributorInterface, IssueInterface,
    PaginationInterface,
} from '@/store/modules/issues/types';
import {GameInterface} from '@/store/modules/games/types';

const namespace: string = 'issuesStateModule';

@Component({
    name: 'c-comments',
    components: {
        'c-user-description': UserDescription,
        'c-comments-form': CommentsForm,

    },
})
export default class Comments extends Vue {
    // Issues contributions
    @Action('fetchContributors', {namespace})
    public fetchContributors!: (contributionConfig: ContributionConfigInterface) => Promise<void>;
    @Getter('getContributors', {namespace})
    public contributors!: ContributorInterface[];
    @Getter('getTotalContributions', {namespace})
    public getTotalContributions!: number;
    @Getter('getContributorsPagination', {namespace})
    public getContributorsPagination!: PaginationInterface;
    @Getter('getCurrentIssue', {namespace: 'issuesStateModule'})
    public getCurrentIssue!: IssueInterface;
    public isReadOnly: boolean = false;
    public currentPage: number = 1;
    public itemsPerPage: number = Contributions.ITEMS_PER_PAGE;
    @Getter('getGames', {namespace: 'gamesStateModule'}) public getGames!: GameInterface[];

    /**
     * Mounted lifecycle hook
     */
    public async mounted(): Promise<void>  {
        const game: GameInterface = this.getGames.find((gameItem: GameInterface): boolean => {
            return this.getCurrentIssue.game === gameItem.name;
        }) as GameInterface;
        for (const eachGame of this.getGames) {
            if (typeof game !== 'undefined' && game.name === eachGame.name && eachGame.readonly === true) {
                this.isReadOnly = true;
            }
        }
    }

    /**
     * Total Pages getter
     */
    public get totalPages(): number {
        return undefined !== this.itemsPerPage ? Math.ceil(this.getTotalContributions / this.itemsPerPage) : 0;
    }

    /**
     * Pagination getter
     */
    public get pagination(): any {
        return this.getContributorsPagination;
    }

    /**
     * Pagination - Navigation to pages
     */
    public async paginate(action: string): Promise<void> {
        await this.fetchContributors({
            issueId: this.getCurrentIssue.id,
            path: this.pagination[action],
            itemsPerPage: this.itemsPerPage,
        });
        switch (action) {
            case 'first': {
                this.currentPage = 1;
                break;
            }
            case 'previous': {
                this.currentPage--;
                break;
            }
            case 'next': {
                this.currentPage++;
                break;
            }
            case 'last': {
                this.currentPage = this.totalPages;
                break;
            }
        }
    }
}
